<vb-dropdown-menu *ngIf="isMenuVisible" [ngClass]="styles.menuWrapper" [alignMenu]="'right'" [cssClass]="styles.menuDropDownContent" [icon]="'more'" [accessibilityTitle]="'Media_Videos_Comments_Menu' | translate">
	<ul [ngClass]="styles.menuDropdown">

		<li *ngIf="menuConfig.showDeleteComment && !menuConfig.isCommentDeleted" [ngClass]="styles.menuItem">
			<button [ngClass]="styles.menuItemLink" (click)="menuItemClick(eventTypes.Delete)">
				{{ 'Delete' | translate }}
			</button>
		</li>

		<li *ngIf="!menuConfig.isCommentDeleted" [ngClass]="styles.menuItem">
			<button [ngClass]="styles.menuItemLink" (click)="menuItemClick(eventTypes.Reply)">
				{{ 'Media_Videos_Comments_Reply' | translate }}
			</button>
		</li>

		<li *ngIf="menuConfig.repliesCount" [ngClass]="styles.menuItem">
			<button [ngClass]="styles.menuItemLink" (click)="menuItemClick(eventTypes.ShowReplies)">
				<ng-container *ngIf="!menuConfig.showReplies" [ngPlural]="menuConfig.repliesCount">
					<ng-template ngPluralCase="=1">{{ 'Media_Videos_Comments_ShowOneReply' | translate }}</ng-template>
					<ng-template ngPluralCase="other">{{ 'Media_Videos_Comments_Menu_ShowReplies' | translate : { '0': menuConfig.repliesCount } }}</ng-template>
				</ng-container>
				<ng-container *ngIf="menuConfig.showReplies" [ngPlural]="menuConfig.repliesCount">
					<ng-template ngPluralCase="=1">{{ 'Media_Videos_Comments_Menu_HideOneReply' | translate }}</ng-template>
					<ng-template ngPluralCase="other">{{ 'Media_Videos_Comments_Menu_HideReplies' | translate : { '0': menuConfig.repliesCount } }}</ng-template>
				</ng-container>
			</button>
		</li>

	</ul>
</vb-dropdown-menu>
